export default function isTrailSymbol(mapboxLayerId: string | undefined) {
    return (
        mapboxLayerId?.includes('trail-longdistance-symbol') ||
        mapboxLayerId?.includes('trail-label') ||
        mapboxLayerId?.includes('trail-longdistance') ||
        mapboxLayerId?.includes('mileage-label')
    );
}
